/* eslint-disable import/prefer-default-export */
import { isEmpty } from 'lodash'
import type { ActionTypes } from '@src/redux/actions/userUsage.actions'
import * as UserUsageAction from '@src/redux/actionTypes/userUsage.action.types'
import { defaultState, UsageState } from './default.state'

export function reducer(state = defaultState, action: ActionTypes): UsageState {
  switch (action.type) {
    case UserUsageAction.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,

        isPending: false
      }
    }

    case UserUsageAction.SET_TABLE_OPTIONS: {
      return {
        ...state,
        tableOptions: action.payload
      }
    }

    case UserUsageAction.CLEANER_STAT: {
      if (!isEmpty(action.payload.stat))
        return {
          ...state,
          [action.payload.stat]: defaultState[action.payload.stat]
        }
      return state
    }

    case UserUsageAction.SET_TIMESTAMP: {
      return {
        ...state,
        startTime: action.payload.startTime,
        endTime: action.payload.endTime
      }
    }

    case UserUsageAction.ON_CHANGE_SEARCH_FILTER: {
      return {
        ...state,
        tableOptions: {
          ...state.tableOptions,
          searchValue: action.payload.searchValue || ''
        }
      }
    }

    case UserUsageAction.ON_CHANGE_COLUMN_FILTER: {
      return {
        ...state,
        tableOptions: {
          ...state.tableOptions,
          searchFields: action.payload.column ? [action.payload.column] : [],
          searchValue: !action.payload.column
            ? ''
            : state.tableOptions.searchValue
        }
      }
    }

    case UserUsageAction.GET_USER_USAGE_SUCCESS: {
      const { pagesCount, usageInfoList, tableOptions } = action.payload
      return {
        ...state,
        tableOptions,
        pagesCount,
        usageInfoList,
        isPending: false
      }
    }
    case UserUsageAction.CLEANING: {
      return {
        ...defaultState,
        startTime: action.payload.startTime || defaultState.startTime,
        endTime: action.payload.endTime || defaultState.endTime
      }
    }
    case UserUsageAction.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    default: {
      return state
    }
  }
}
